module.exports = __webpack_public_path__ + "img/logo.9210bcb4.png";